import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../store';
import { Panel } from './Panel';
import { IconBack } from './icons';

export function CoursePanel() {
  const { t } = useTranslation();
  const course = useStore((s) => s.course);
  const stats = useStore((s) => s.stats);
  const selectedField = useStore((s) => s.selectedField);
  const startDriving = useStore((s) => s.startDriving);
  const backToField = useStore((s) => s.backToField);
  const saveCurrentCourse = useStore((s) => s.saveCurrentCourse);

  const defaultName = (selectedField?.properties.name as string) ?? 'Feld';
  const [name, setName] = useState('');
  const [saved, setSaved] = useState(false);

  if (!course) return null;
  const laneCount = new Set(course.lanes.map((l) => l.index)).size;

  async function save() {
    await saveCurrentCourse(name.trim() || defaultName);
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  }

  return (
    <Panel>
      <div className="flex items-baseline justify-between">
        <h2 className="text-lg font-semibold">{t('course.title')}</h2>
        <span className="text-sm text-white/60">
          {t('course.lanes', { n: laneCount, w: course.widthM.toFixed(1) })}
        </span>
      </div>

      {stats && (
        <p className="mt-2 text-sm tabular-nums text-white/50">
          {t('field.stats', {
            lanes: stats.lanes,
            turns: stats.turns,
            km: (stats.totalLengthM / 1000).toFixed(1),
            min: Math.round(stats.estMinutes),
          })}
        </p>
      )}

      <div className="mt-4 flex gap-2">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={`${t('course.namePlaceholder')} (${defaultName})`}
          className="min-w-0 flex-1 rounded-xl bg-zinc-800 px-3 py-3 text-sm outline-none placeholder:text-white/40"
        />
        <button
          onClick={save}
          className={`rounded-xl px-4 py-3 text-sm font-semibold ${saved ? 'bg-emerald-700' : 'bg-zinc-700'}`}
        >
          {saved ? t('course.savedOk') : t('course.save')}
        </button>
      </div>

      <div className="mt-3 flex gap-3">
        <button
          onClick={backToField}
          aria-label={t('course.back')}
          className="flex items-center justify-center rounded-2xl bg-zinc-700 px-4 py-3"
        >
          <IconBack />
        </button>
        <button
          onClick={startDriving}
          className="flex-1 rounded-2xl bg-emerald-500 py-3 text-xl font-bold text-emerald-950 active:scale-[0.99]"
        >
          {t('course.go')}
        </button>
      </div>
    </Panel>
  );
}
